export default __webpack_public_path__ + "static/media/us-lecce.94944fa3.png";